/** Part 2 slice A — through parameterDocuments */
import {
	workspaceAdminLabel,
	workspaceAllLabel,
	workspaceOfPhrase,
	workspacePluralTitle,
	workspaceUnknownLabel,
} from "@Front/Utils/publicSiteBranding";

export const COMMON_UI_I18N_PART2_SLICE_A = {
	siteTextsAdmin: {
		createModalTitle: "Nouveau texte",
		createKeyLabel: "Clé",
		createKeyPlaceholder: "ex: login.header.title",
		createScopeLabel: "Scope",
		createScopePlaceholder: "ex: login",
		createLocaleLabel: "Locale",
		createContentLabel: "Contenu",
		createDescriptionLabel: "Description (optionnel)",
		createSummaryLabel: "Résumé des modifications",
		createSummaryPlaceholder: "Pourquoi ce texte est ajouté",
		createContentHtmlLabel: "Contenu HTML",
		editDescriptionLabel: "Description (optionnel)",
		editSummaryLabel: "Résumé des modifications",
		editSummaryPlaceholder: "Documentez la modification",
		editSaveAndPublishCta: "Enregistrer & publier",
		filtersSearchLabel: "Recherche",
		filtersSearchPlaceholder: "Clé, scope ou contenu…",
		filtersLocaleLabel: "Locale",
	},
	subscriptionPage: {
		titleNew: "Nouvelle souscription",
		titleSuccess: "Abonnement réussi",
		titleError: "Erreur à la souscription",
		inviteEmailPlaceholder: "Email",
		frequencyYearly: "Annuel",
		frequencyMonthly: "Mensuel",
		modalCancelConfirmTitle: "Êtes-vous sûr de vouloir arrêter votre abonnement ?",
		modalCancelSuccessTitle: "Abonnement résilié avec succès",
		seatManagement: {
			sectionTitle: "Sièges et accès collaborateurs",
			capacityLabel: "Places souscrites",
			usedLabel: "Occupées",
			freeLabel: "Libres",
			policyHintTrimNewest:
				"Si vous réduisez le nombre de places, les accès créés en dernier sont retirés en premier pour respecter la limite souscrite.",
			policyHintTrimOldest:
				"Si vous réduisez le nombre de places, les accès créés en premier sont retirés en premier pour respecter la limite souscrite.",
			stripePortalOnlyCapacity:
				"Le nombre de places facturées se modifie uniquement via l’espace client Stripe (portail d’abonnement). Les retraits d’accès ci-dessous libèrent une place sans changer la quantité facturée.",
			tableUser: "Collaborateur",
			tableEmail: "E-mail",
			tableSince: "Accès depuis",
			revokeCta: "Retirer l'accès",
			applyCapacityCta: "Mettre à jour le nombre de places",
			capacityInputLabel: "Nombre de places",
			loadError: "Impossible de charger la répartition des accès pour cette étude.",
			saveError: "L'enregistrement a échoué. Vérifiez les droits et la capacité.",
			revokeConfirm: "Retirer l'accès pour ce collaborateur ? Une place se libère ; il pourra être réattribué plus tard si une place est disponible.",
			adminOfficePickerHint:
				"Recherchez une étude par son nom ou par son identifiant IdNot (au moins 2 caractères) ou choisissez-en une dans la liste ci-dessous. Les données correspondent au site actuellement ouvert.",
			adminOfficePickerSearchPlaceholder: "Nom ou IdNot…",
			adminOfficePickerBrowseCaption: "Études avec abonnement actif, par ordre alphabétique sur le nom. Affinez avec la recherche.",
			adminOfficePickerTableStudy: "Étude (nom IdNot)",
			adminOfficePickerTableCrpcen: "CRPCEN",
			adminOfficePickerTableSeats: "Sièges (occupés / total)",
			adminOfficePickerTableUsers: "Utilisateurs",
			adminOfficePickerOpenCta: "Afficher les sièges",
			adminOfficePickerShowUnlimitedCta: "Afficher les abonnements illimités",
			adminOfficePickerHideUnlimitedCta: "Masquer les abonnements illimités",
			adminOfficePickerEmpty: "Aucune étude ne correspond à cette recherche.",
			adminOfficePickerLoadError: "Impossible de charger la liste des études. Réessayez plus tard.",
			adminOfficePickerNavMissing: "La sélection d'étude n'est pas disponible sur cet écran.",
			adminOfficePickerSearching: "Recherche en cours…",
			multisiteNote: "Les données affichées correspondent au site ouvert dans le navigateur. Pour une autre ligne métier, utilisez l'URL de ce site.",
		},
	},
	adminDashboard: {
		kpiOffices: workspacePluralTitle(),
		kpiFolders: "Dossiers",
		kpiUsers: "Utilisateurs",
		kpiDocuments: "Documents",
		kpiActiveSubscriptions: "Abonnements actifs",
		chartOfficesTitle: `${workspacePluralTitle()} (par mois)`,
		chartFoldersTitle: "Dossiers (par mois)",
		chartUsersTitle: "Utilisateurs (par mois)",
		chartDocumentsTitle: "Documents (par mois)",
		chartSubscriptionsTitle: "Abonnements Actifs (par mois de création)",
		pageTitle: "Dashboard Admin",
		seatsPageTitle: "Sièges par bureau",
		loading: "Chargement...",
		errorTitle: "Erreur",
		unknownError: "Erreur inconnue",
		unknownDate: "Date inconnue",
		documentUnknownName: "Sans nom",
		folderNoNumber: "Sans numéro",
		officeUnknown: workspaceUnknownLabel(),
		stripeEventsTitle: "Événements Stripe (mois précédent + mois en cours)",
		createdOn: "Créé le",
		priceIdNa: "N/A",
		stripeIdLabel: "Stripe ID",
		priceIdLabel: "Price ID",
		seatsLabel: (n: number) => (n > 1 ? "sièges" : "siège"),
		monthlyCountersTitle: "Activité mensuelle",
		monthlyCountersDescription: "Compteurs calendaires mensuels et export CSV par mois.",
		noMonthlyCountersData: "Aucune donnée mensuelle disponible pour le moment.",
		monthlyCountersActiveOffices: "Offices actifs durant le mois",
		monthlyCountersNewSubscriptions: "Nouveaux abonnements",
		monthlyCountersNewAssignedSeats: "Nouveaux sièges attribués",
		monthlyCountersActiveNotaryUsers: "Utilisateurs notaires actifs durant le mois",
		monthlyCountersActiveNotaryThirdParties: "Tiers notaires actifs durant le mois",
		monthlyCountersActiveInvitedNotaries: "Notaires invités actifs durant le mois",
		monthlyCountersIpfsDocumentsInActiveFolders: "Nombre de documents IPFS dans les dossiers actifs", monthlyCountersLocalDocumentsInActiveFolders: "Nombre de documents locaux dans les dossiers actifs",
		monthlyCountersFoldersWithPermanentArchiving: "Nombre de dossiers avec archivage permanent",
	},
	superAdminPages: {
		rolesManagementTitle: "Gestion Rôles & Règles",
		forfaitsTitle: "Gestion des Forfaits",
	},
	folderTitles: {
		selectFolder: "Sélectionner un dossier",
		createFolder: "Créer un dossier",
		addThirdParty: "Ajouter un tiers",
		clients: "Clients",
		validatedDocuments: "Documents validés",
		refusedDocuments: "Documents refusés",
		otherDocuments: "Autres documents",
		askedDocuments: "Documents demandés",
		noDocumentRequest: "Aucune demande de document",
		archivedFolder: "Dossier archivé",
		invitedNotaries: "Notaires invités",
		invitedThirdParties: "Tiers invités",
		sharedFoldersLabel: "Dossiers invités",
		sharedFoldersLabelWithCount: (count: number): string => `Dossiers invités (${count})`,
		guestFoldersDisabledNoInvitationsTitle:
			"Aucun dossier ne vous a été partagé en tant que notaire invité sur cette étude.",
		guestFoldersDisabledFromCurrentOfficeTitle:
			"Aucun dossier invité pour le cabinet sélectionné (0). Choisissez le cabinet qui vous a invité dans le menu en haut, puis rouvrez Dossiers invités.",
		officeFoldersLabel: `Dossiers ${workspaceOfPhrase()}`,
		/** Bandeau sidebar notaire : choix entre dossiers office et dossiers invités. */
		folderSidebarConnectPrompt: "Connectez-vous sur :",
	},
	folderListHome: {
		greetingWithName: (firstName: string, lastName: string): string => {
			const parts = [firstName, lastName].filter((p) => p.length > 0);
			const full = parts.join(" ").trim();
			return full.length > 0 ? `Bonjour ${full}` : "Bonjour";
		},
		pendingValidationDocuments: (n: number): string => {
			const noun = n === 1 ? "document" : "documents";
			return `Vous avez ${n} ${noun} en attente de validation.`;
		},
		documentsToSend: (n: number): string => {
			const noun = n === 1 ? "document" : "documents";
			return `Vous avez ${n} ${noun} à envoyer.`;
		},
		loadingDocumentsLine: "Chargement des documents…",
		guestFoldersSelectInvitingOfficeLine:
			"Sélectionnez le cabinet qui vous a invité (menu en haut) pour accéder aux dossiers invités.",
	},
	folderForm: {
		folderLabel: "Intitulé du dossier",
		folderPlaceholder: "Entrer l'intitulé du dossier",
		folderNumberLabel: "Numéro de dossier",
		folderNumberPlaceholder: "Entrer le numéro de dossier",
		deedTypePlaceholder: "Type d'acte",
		selectDeedTypePlaceholder: "Sélectionner un type d'acte",
		loadingDeedTypesPlaceholder: "Chargement des types d'acte...",
		openingDatePlaceholder: "Ouverture du dossier",
		noteLabel: "Note du dossier",
		notePlaceholder: "Renseigner une note",
		folderTypeSummaryLabel: "Type de dossier",
		intituleLabel: "Intitulé",
		deedTypeLabel: "Type d'acte",
		/**
		 * Groupe affiché pour les types d’acte sans `deed_category` en base (tous sites, liste homogène).
		 */
		deedTypesDefaultCategoryLabel: "Types d'actes",
		noteDossierLabel: "Note de dossier",
		allOfficeLabel: workspaceAllLabel(),
		selectCollaboratorsLabel: "Sélectionner des collaborateurs",
		existingDocumentLabel: "Document existant",
		clientNotePlaceholder: "Note à l'attention du client",
		companyLabel: "Nom de la société",
		companyPlaceholder: "Courtage Immobilier Pro",
		firstNamePlaceholder: "Jean",
		lastNamePlaceholder: "MARTIN",
		emailPlaceholder: "jmartin@courtage.fr",
		descriptionOptionalLabel: "Description (facultatif)",
		updateMetadataSidebarTitleInformations: "Modifier les informations",
		updateMetadataSidebarTitleDescription: "Modifier la description",
		updateMetadataH1Informations: "Modifier les informations du dossier",
		updateMetadataH1Description: "Modifier la description du dossier",
	},
	documentModals: {
		validateTitle: "Valider le document ?",
		refuseTitle: "Refuser le document ?",
		refuseReasonTitle: "Motif de refus",
		viewRefusalReasonLink: "Voir le motif de refus",
		understoodCta: "J'ai compris",
	},
	collaboratorLabels: {
		lastName: "Nom",
		firstName: "Prénom",
		phone: "Numéro de téléphone",
		email: "Email",
		rolePlaceholder: "Rôle",
		adminOfficeSwitch: workspaceAdminLabel(),
	},
	clientDashboard: {
		personalInfoTitle: "Informations personnelles",
		creationDetailsTitle: "Détails de création",
	},
	confirmExit: {
		title: "Êtes-vous sûr de vouloir quitter sans enregistrer ?",
	},
	loginCallback: {
		cannotConnectTitle: "Vous n'arrivez pas à vous connecter ?",
	},
	pageNotFound: {
		questionsTitle: "Vous avez des questions ?",
	},
	incidentReport: {
		namePlaceholder: "Votre nom *",
		emailPlaceholder: "Votre email *",
		subjectPlaceholder: "Sujet *",
		messagePlaceholder: "Décrivez le problème rencontré *",
		pageTitle: "Déclaration d'incident",
		pageDescription:
			"Vous avez rencontré un problème ? Décrivez-le ci-dessous et notre équipe vous répondra dans les plus brefs délais.",
		successTitle: "Déclaration envoyée",
		successDescription:
			"Votre déclaration d'incident a été envoyée avec succès. Notre équipe vous répondra dans les plus brefs délais.",
		cancelCta: "Annuler",
		submitCta: "Envoyer",
	},
	thirdPartyLogin: {
		emailLabel: "Email",
		emailPlaceholder: "votre@email.fr",
		codePlaceholder: "123456",
		sendCodeCta: "Envoyer un code",
		continueCta: "Continuer",
	},
	myAccount: {
		idNotLabel: "Identifiant ID.NOT",
		idNotPlaceholder: "Identifiant ID.NOT",
		/** Lien externe Mon compte → portail compte ID.not (nouvel onglet) */
		idnotPortalOpensNewTab: "Ouvre le portail de gestion du compte ID.not dans un nouvel onglet",
	},
	askDocuments: {
		selectDocumentsLabel: "Sélectionner des documents",
		selectAllEnabled: "Tout cocher",
		selectForCurrentRole: "Cocher pour ce rôle",
	},
} as const;
